export enum ServicioEstado {
  pendiente = "PENDIENTE",
  asignado = "ASIGNADO",
  finalizado = "FINALIZADO",
  rechazado = "RECHAZADO",
  aprobado = "APROBADO",
  realizadorPorError = "REALIZADO_POR_ERRROR",
  incorporado = "INCORPORADO",
}
